export const domains = ['Zuverlässigkeit', 'Sicherheit', 'Kostenoptimierung', 'Operationale Exzellenz', 'Leistungseffizienz'] as const;

type FrameworkDomain = typeof domains[number]; //casts possible strings from domains and basically converts it into an enum

export default FrameworkDomain;
